export default {
    computed: {
      /**
       * Determine if user is an admin.
       *
       * @return bool
       */
      isAdmin () {
        return this.authorized.role && this.authorized.role.name === "admin"
      },

      userFirstName () {
        if (this.user.name) {
          return this.user.name.split(' ')[0]
        }

        return ''
      },

      userSurname () {
        if (this.user.name) {
          var nameComponents = this.user.name.split(' ')

          if (nameComponents.length > 2) {
            return this.user.name.split(' ').splice(1, -1).join(' ')
          } else if (nameComponents.length > 1) {
            return this.user.name.split(' ')[1]
          }
        }

        return ''
      }
    },

    methods: {
      getAvatar (id) {
        return process.env.VUE_APP_API_URL + '/user/' + id + '/avatar';
      },

      role(roleId) {
        return roleId == 1 ? 'Admin' : 'Developer'
      }
    }
}
